import type { DashboardState } from '../index';

export const setEmail = (state: DashboardState, { payload }: { payload: string }) => {
  state.email = payload;
};
